import { Reset } from "@bluframe/blublocks"
import styled from "styled-components"

export const Ul = styled(Reset.Ul)`
  display: grid;
  row-gap: 10px;
`

export const Li = styled.li``
